import { Subscription } from 'rxjs/Subscription';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { UtilHelper, NbpConfirmComponent } from '../../../shared';

import { RecuperacaoSenhaService } from '../../../shared/service/recuperacao-senha.service';

import { ConsumidorModel, ConsumidorService } from '../shared/';
import { AlterarSenhaModel } from '../consumidor-alterar-senha/alterar-senha.model';
import { LoadingService } from '../../../shared-layout/loading/loading.service';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';


@Component({
  selector: 'app-consumidor-senha-logado',
  templateUrl: './consumidor-senha-logado.component.html',
  styleUrls: []
})
export class ConsumidorSenhaLogadoComponent implements OnInit, OnDestroy {

  public senhaAlterada = false;
  public erroSenhaAlterada = false;
  public consumidorAlterarSenhaForm: FormGroup;
  public msgSenhaAlteracao: string = null;
  public unsubAlterarSenhaForm: Subscription;

  public formErrors = {
    'senhaAtual': [],
    'senhaGroup.senha': [],
    'senhaGroup.confirmarSenha': [],
    'senhaGroup': []
  };

  public validationMessages = {
    'senhaAtual': {
      'required': 'O Campo Senha Atual é de preenchimento obrigatório.',
      'minlength': UtilHelper.MsgGenericas.senha_minlength,
      'senhaInvalida': 'Senha Incorreta. A senha atual informada está incorreta.'
    },
    'senhaGroup.senha': {
      'required': 'O Campo Nova Senha é de preenchimento obrigatório.',
      'minlength': UtilHelper.MsgGenericas.senha_minlength,
      'valorDiferente': UtilHelper.MsgGenericas.senha_naoConfirmada
    },
    'senhaGroup.confirmarSenha': {
      'required': 'O Campo Confirmar Nova Senha é de preenchimento obrigatório.',
      'minlength': UtilHelper.MsgGenericas.senha_minlength,
      'valorDiferente': UtilHelper.MsgGenericas.senha_naoConfirmada
    },
    'senhaGroup': {
      'senhaNaoConfirmada': UtilHelper.MsgGenericas.senha_naoConfirmada
    }
  };

  constructor(private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly consumidorService: ConsumidorService,
    private readonly recuperacaoSenhaService: RecuperacaoSenhaService,
    private readonly ngbModalService: NgbModal,
    private readonly loadingService: LoadingService) { }

  ngOnInit() {
    this.consumidorAlterarSenhaForm = new FormGroup({
      'senhaAtual': new FormControl(null, [Validators.required, Validators.minLength(6)]),
      'senhaGroup': new FormGroup({
        'senha': new FormControl(null,
          [Validators.required, Validators.minLength(6), Validators.maxLength(15)]),
        'confirmarSenha': new FormControl(null,
          [Validators.required, Validators.minLength(6), Validators.maxLength(15)])
      }, this.passwordMatchValidator)
    });

    this.unsubAlterarSenhaForm = this.consumidorAlterarSenhaForm.valueChanges
      .subscribe(
      (data) => {
        UtilHelper.onValueChanged(data, this.formErrors, this.validationMessages, this.consumidorAlterarSenhaForm);
        this.erroSenhaAlterada = false;
        this.msgSenhaAlteracao = '';
      }
      );
  }

  passwordMatchValidator(g: FormGroup) {
    if (!g.get('senha').valid || !g.get('confirmarSenha').valid) {
      return null;
    }

    if (!g.get('senha').value && !g.get('confirmarSenha').value) {
      return null;
    }

    if (g.get('senha').value !== g.get('confirmarSenha').value) {
      return { 'senhaNaoConfirmada': true };
    }

    return null;
  }

  ngOnDestroy() {
    this.unsubAlterarSenhaForm.unsubscribe();
  }

  private onAlterarSenha() {
    this.modalAlterarSenha();
  }

  private onAlterarSenhaNovo() { 
    this.modalAlterarSenha();
  }

  private cancelaAlterarSenha() {
    const confirmModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });
    confirmModal.componentInstance.mensagem = 'Você tem certeza que deseja cancelar a alteração da senha?'

    const unsubConfirm = confirmModal.componentInstance.userConfirmChange
      .subscribe(
      (userConfirm) => {
        if (userConfirm) {
          this.router.navigate(['consumidor/detalhar']);
          unsubConfirm.unsubscribe();
        }
      }
      );
  }

  private modalAlterarSenha() {

    const consumidor: ConsumidorModel = this.consumidorService.getConsumidorModel();
    const cpf: string = UtilHelper.lpad(consumidor.cpfBase.toString(), 9) + '' + UtilHelper.lpad(consumidor.cpfDigito.toString(), 2);
    const senha: string = this.consumidorAlterarSenhaForm.get('senhaGroup').value['senha'];
    const confirmacaoSenha: string = this.consumidorAlterarSenhaForm.get('senhaGroup').value['confirmarSenha'];
    const alterarSenha: AlterarSenhaModel = new AlterarSenhaModel(cpf, senha, confirmacaoSenha);
    alterarSenha.senhaAtual = this.consumidorAlterarSenhaForm.controls['senhaAtual'].value;

    
    const s: Subscription = this.recuperacaoSenhaService.putAlterarSenhaCidadaLogado(alterarSenha)
    .subscribe(
      (mensagem: string) => {

        this.loadingService.exibirLoading("Aguarde");

        s.unsubscribe();
        
        this.consumidorService.isSenhaAlterada = true;
        const s2: Subscription = this.consumidorService.getConsumidorPeloCPFString(cpf).subscribe(
          (cons: ConsumidorModel) => {
            s2.unsubscribe();
            this.consumidorService.setConsumidorModel(cons);
            this.loadingService.esconderLoading();
            this.router.navigate(['consumidor/msg_alterar_senha']);
          },
        );
      },
      (error) => {

        // Apresenta a mensagem de erro para o usuário.
        let erro = error as StatusRequisicao;
        
        this.msgSenhaAlteracao = erro.motivo;
        this.erroSenhaAlterada = true;

        s.unsubscribe();
        this.loadingService.esconderLoading();
      },
      () => {
         this.loadingService.esconderLoading();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-senha-logado/consumidor-senha-logado.component.ts